import { render, staticRenderFns } from "./lainakaruselli.vue?vue&type=template&id=984bf304&"
import script from "./lainakaruselli.vue?vue&type=script&lang=js&"
export * from "./lainakaruselli.vue?vue&type=script&lang=js&"
import style0 from "./lainakaruselli.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports